export default __webpack_public_path__ + "static/media/socialshare.a01a0485.svg";